export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40793095fd1a1e9863662476a62c8aba69f7095a0d&name=revalidateCommunity!'